const ETON_BLUE = '#87CBAC'
const CERULEAN_BLUE = '#3066BE'
const VERY_DARK_GREY = '#1a1a1a'
export default {
    ETON_BLUE,
    CERULEAN_BLUE,
    VERY_DARK_GREY,
}
